import exception from './zh-CN/exception';
import menu from './zh-CN/menu';
import login from './zh-CN/login';
import globalHeader from './zh-CN/globalHeader';

export default {
  'layout.user.link.home': '官网',
  ...exception,
  ...menu,
  ...login,
  ...globalHeader,
};
